export default __webpack_public_path__ + "assets/2WhiteCat.png";